export const text = {
  login: "Login",
};
